import moment from 'moment';
import { format, parseISO } from 'date-fns';

const enhancedFormatDate = date => format(parseISO(date), 'dd/MM/yyyy');
const oldFormatDate = date => moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');

export const formatHour = date => format(parseISO(date), 'HH:mm');
export const formatDate = (date, isEnabled) => (isEnabled ? enhancedFormatDate(date) : oldFormatDate(date));
